import { SubscriptionStatus } from '../../../models';
import { INACTIVE_STATE } from '../constants';

export const useSubscriptionIsActive = (
  subscriptionStatus: SubscriptionStatus
) => !INACTIVE_STATE.includes(subscriptionStatus);
